var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout1',{attrs:{"is-demo":""}},[_c('h1',{staticClass:"text-h4"},[_vm._v("Generate Invoice")]),_c('GenerateInvoiceCardStarter',{staticClass:"pa-0 py-2"}),_c('v-divider',{staticClass:"my-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }